export default __webpack_public_path__ + "images/anim-edge-transparent-small.56f88991a75e0b5c5093d3a13cda87a0.gif";